module.exports = __webpack_public_path__ + "static/media/linkedin.f19652f3.svg";